import './css/aboutus.css'

import blank from './aboutus/img/blank.png'

//  Coordinators
import wk from './aboutus/img/wk.jpg'
import sl from './aboutus/img/sl.jpg'
import nnk from './aboutus/img/nnk.jpg'
import sp from './aboutus/img/sp.jpg'
import dm from './aboutus/img/dm.png'

//  Members
import rh from './aboutus/img/members/rh.jpg'
import mh from './aboutus/img/members/mh.jpg'
import vp from './aboutus/img/members/vp.jpg'
import fl from './aboutus/img/members/fl.jpeg'

import React, { useEffect, useState } from 'react'
import Parse from 'html-react-parser'

// logo
import logo from './aboutus/img/presto-logo.png'

// import aims
import dna from './aboutus/img/aims/dna.png'
import gear from './aboutus/img/aims/gear.png'
import bat from './aboutus/img/aims/bat.png'
import pin from './aboutus/img/aims/pin.png'
import people from './aboutus/img/aims/people.png'
//  aims bgimg
import bgdna from './aboutus/img/aims/bgdna.png'
import bggear from './aboutus/img/aims/bggear.png'
import bgbat from './aboutus/img/aims/bgbat.png'
import bgpin from './aboutus/img/aims/bgpin.png'
import bgpeople from './aboutus/img/aims/bgpeople.png'

const Aboutus = () => {

    const aims = [
        {
            id:1,
            head: 'AIM 1',
            details: 'Molecular characterization /epidemiology of pathogens of zoonotic potential',
            imgSrc: dna,
            bgimg: bgdna
        },
        {
            id:2,
            head: 'AIM 2',
            details: 'Identify animal reservoirs',
            imgSrc: bat,
            bgimg: bgbat
        },
        {
            id:3,
            head: 'AIM 3',
            details: 'Identify biodiversity rich areas/ anthropogenic pressure',
            imgSrc: pin,
            bgimg: bgpin
        },
        {
            id:4,
            head: 'AIM 4',
            details: 'Identify behavior risks of exposure and susceptible human populations',
            imgSrc: people,
            bgimg: bgpeople
        },
        {
            id:5,
            head: 'AIM 5',
            details: 'New detection tests/ validation',
            imgSrc: gear,
            bgimg: bggear
        },
    ]

    const coordinators = [
        {
            id:5,
            ini: "DM",
            name: 'Dorothée Missé',
            orcid: 'https://orcid.org/0000-0002-6485-3841',
            orcidlink: 'https://orcid.org/0000-0002-6485-3841',
            cv: `Dr Dorothée Missé co-heads the “Biology of Viral Infection” Department at IRD MIVEGEC Unit. She works on the pathogenesis of emerging and re-emerging viruses (Dengue, Chikungunya, Zika, Mayaro...viruses) with a focus on virus-host interactions and innate immunity and antiviral compound discovery. Her team has pioneered the field of Zika virus biology and also provided significant information regarding the role of the skin and mosquito saliva in arbovirus transmission. Dr Missé is also known for her work on the mechanisms involved in DENV transmission in humans and in mosquitoes.  She has contributed to >113 studies including those in Nat. Biotechnol., PNAS., PLoS Path., PLoS Biology, Trends in Ecol. Evol., Blood, Cell Report, as well as four patents. She has also developed a team of scientists in Thailand (Mahidol University) whose projects are closely linked to IRD’s research priorities. She is involved in various "One Health" projects in Africa  (Zimbabwe & Cameroon). Dr Missé is also a nominated member of the CBS2 Doctoral School office at the Montpellier University of Excellence.`,
            email: `dorothee.misse@ird.fr`,
            imgSrc: dm,
            national: 'FR'
        },
        {
            id:3,
            ini: "wk",
            name: 'Woottichai Khamduang',
            orcid: 'https://orcid.org/0000-0003-0196-5691',
            orcidlink: 'https://orcid.org/0000-0003-0196-5691',
            cv: `Woottichai Khamduang, is Assistant Prof at the Faculty of Associated Medical Sciences, Chiang Mai University since 2016. His activities include teaching, research, and community health services. He holds dual PhD degrees in Biomedical Sciences and Life and Health Sciences from Chiang Mai University and Université François Rabelais, respectively.  His research interests focus on addressing critical health challenges and improving access to and diagnosis of infectious diseases. He has extensive expertise in virology and medical technology and has been involved in numerous high-impact research projects, particularly on HIV, hepatitis B, and emerging infectious diseases. His academic and research endeavors have positioned him as a leader in virology and public health in the region.`,
            email: `woottichai.k@cmu.ac.th`,
            imgSrc: wk,
            national: 'TH'
        },
        {
            id:2,
            ini: "sl",
            name: 'Sabrina Locatelli',
            orcid: 'https://orcid.org/0000-0002-1133-0561',
            orcidlink: 'https://orcid.org/0000-0002-1133-0561',
            cv: `Sabrina Locatelli is a Swiss researcher specializing in molecular biology, epidemiology, and conservation, with a focus on zoonotic diseases and wildlife sampling. She earned her Doctorate in Public Health and Epidemiology from the University of Basel and completed postdoctoral work in the USA. Sabrina has led international research projects, particularly in Laos, where she has been based since 2021 and currently serves as the IRD representative. She is recognized for her contributions to global health research. She is also actively involved in teaching, capacity-building, and scientific diplomacy, with fluency in multiple languages.`,
            email: `sabrina.locatelli@ird.fr`,
            imgSrc: sl,
            national: 'LA'
        },
        {
            id:1,
            ini: "nnk",
            name: 'Nicole Ngo-Giang-Huong',
            orcid: 'https://orcid.org/0000-0001-8950-3234',
            orcidlink: 'https://orcid.org/0000-0001-8950-3234',
            cv: `Nicole Ngo-Giang-Huong is research director at the MIVGEC unit, French National Research Institute for Sustainable Development. She holds a PharmD degree from Paris XI and a PhD in Immunology from University Paris VII Denis Diderot. She has extensive experience in medical biology, particularly clinical virology. She has led various projects on the molecular analysis of HIV, HCV and HBV in Southeast Asia since 2001. She has been member of several scientific committees and international networks.`,
            email: `nicole.ngo-giang-huong2@ird.fr`,
            imgSrc: nnk,
            national: 'TH'
        },
        {
            id:4,
            ini: 'sp',
            name: 'Sysay Palamy',
            orcid: 'https://orcid.org/0000-0001-6510-1097',
            orcidlink: 'https://orcid.org/0000-0001-6510-1097',
            cv: `Sysay Palamy is a distinguished academic and researcher, currently serving as the Head of the Department of 
            Pharmaceutical Sciences at the Faculty of Pharmacy, University of Health Sciences, Laos. He also holds the position of 
            Sub-committee of Biotechnology-Laos. His research expertise lies in pharmaceutical sciences, with a particular emphasis on 
            quality control of pharmaceutical products, including foods, cosmetics, herbal medicine, and modern medicine. His research interests 
            extend to the field of One Health, focusing on issues such as heavy metal contamination in the environment and food products, antibiotic 
            residue in meat, and lead exposure in nurseries, primary schools, and toys. He is also passionate about sustainable extraction techniques, 
            specifically Supercritical Fluid Extraction (SFE-CO2) and Pressurized Liquid Extraction (PLE). He has been an active participant in several 
            international research collaborations, including the COCLICAN project (2019-2022), the ROCKET project (2021-2023), and the Mekong Pharma 
            Network project (Laos, Vietnam, and Cambodia) in 2022-2024.`,
            email: `sysaypharma@gmail.com`,
            imgSrc: sp,
            national: 'LA'
        }
    ]

    const members = [
        {            
            id:1,
            ini: "RH",
            name: 'Rodolphe Hamel',
            orcid: 'https://orcid.org/0000-0001-8603-7039',
            orcidlink: 'https://orcid.org/0000-0001-8603-7039',
            cv: `He is a researcher in the department EDIFICE at unit MIVEGEC-IRD in Montpellier – France and assigned as Adjunct Professor at Mahidol University – Bangkok. Virologist, specialized in the study of arboviruses, my research focuses on i) the ecology of arboviruses and insect vectors at human-animal interface; ii) on “vertebrate host-vector-virus” interactions with specific investigation on emergence, molecular mechanisms involved in infectious processes and viral evasion. He manage different projects in collaboration with partners based in Thailand, Lao, Japan, and Taiwan.`,
            email: `rodolphe.hamel@ird.fr`,
            imgSrc: rh,
            national: 'TH'
        },
        {
           id:2,
           ini: "MH",
           name: 'Marco J Haenssgen',
           orcid: 'https://orcid.org/0000-0002-5849-7131',
           orcidlink: 'https://orcid.org/0000-0002-5849-7131',
           cv: `Marco J Haenssgen is Assistant Professor at the Department of Social Science and Development at Chiang Mai University, where he has been conducting research on Indigenous people’s experiences of conservation policy and land use change. With more than ten years of experience in international research projects across Southeast Asia, a central part of Marco’s mission is to acquaint the broader public with pressing problems of science and society, which has led into the creation of participatory storytelling and international multimedia exhibitions like “Tales of Treatment” in 2018 and 2019 (Chiang Rai, Bangkok, Oxford, Coventry), the “Being Me” event showcasing ethnic identity among Thai youth in 2022 (Chiang Mai), and the “Nurturing Lives in the Forest” documentary project. At present, he leads a research project funded by the British Academy to trial innovative policy pilots to support Indigenous environmental heritage in the Thai highlands.`,
           email: `m.haenssgen@outlook.com`,
           imgSrc: mh,
           national: 'TH'
        },
        {
           id:3,
           ini: "VP",
           name: 'Vannaphone Phouthana',
           orcid: 'https://orcid.org/0000-0002-3176-3567',
           orcidlink: 'https://orcid.org/0000-0002-3176-3567',
           cv: `Currently serving as Vice Dean of the Faculty of Agriculture at the National University of Laos (NUOL) and Vice Chair of LAOHUN, Dr. Vannaphone Phouthana brings extensive expertise in veterinary medicine and food safety to his roles. Since joining NUOL's Veterinary Medicine Department in 2004, he has established himself as a distinguished lecturer in animal disease and medicine, epidemiology, food safety, and One Health approaches.
                <p style="margin: 0; padding:">Dr. Phouthana earned his Ph.D. in Food Microbes from the Czech University of Life Science in 2012, building upon his Master's degree in Animal Health from Khonkaen University, Thailand. His research portfolio includes coordinating significant projects across Laos, including studies on safe pork production in Savannakhet and Champasak provinces, investigations of poultry value chains and field diseases in northern Laos, and research on parasitic foodborne diseases in the country's southern region. These initiatives, including the EU-supported GREASE and CommAcross projects, demonstrate his commitment to improving food security and animal health in the region.</p>
                <p style="margin: 0; padding:">As an accomplished academic, he has contributed to the field through 14 published articles and three book chapters, focusing on transboundary animal diseases and food security challenges in Southeast Asia</p>`,
           email: `V.phouthana@nuol.edu.la`,
           imgSrc: vp,
           national: 'LAOS'
        },
        {
           id:4,
           ini: "FL",
           name: 'Florian Liégeois',
           orcid: 'https://orcid.org/0000-0003-1048-066',
           orcidlink: 'https://orcid.org/0000-0003-1048-066',
           cv: `Florian Liégeois is a virologist at the IRD MIVEGEC unit. His research focuses on understanding the ecological and evolutionary drivers of viral circulation at the human–animal–environment interface. Using a One Health approach, he investigates the circulation, prevalence and molecular epidemiology of viruses in wildlife populations, as well as their interactions with domestic animals and humans in Africa. Through the integration of field surveillance, molecular analyses, and ecological data, he aims to identify the biotic and abiotic factors that facilitate interspecies transmission and influence the risk of viral emergence. Ultimately, his research aims to provide actionable insights to improve the early detection of emerging pathogens and inform strategies to mitigate the threat of zoonotic diseases.`,
           email: `florian.liegeois@ird.fr`,
           imgSrc: fl,
           national: 'French'
        },
    ]   

    const [active, setActive] = useState('')
    const handlePopup = (e) =>{
        const key = e.currentTarget.getAttribute('data-key')
        setActive(prevActive => prevActive === key ? '' : key)
    }

    useEffect(()=>{
        const popUp = () =>{
            if(active){
                const elements = document.querySelectorAll(`.containers ${active}`)
                elements.forEach(element =>{
                    element.classList.toggle('active')
                })
            }else{
                return
            }
        }
        popUp()
    },[active])
    

    return(
        <div className="aboutus">
            <div className="aboutus-modal" style={{display: active ? 'block' : 'none'}} onClick={handlePopup}></div>
            <div className="cover">
                <div className="cover-bg"></div>
                <div className="cover-text flyIn">
                    <h1>ABOUT US</h1>
                </div>
            </div>

{/* ABOUT */}
            <div className="about">
                <div className="container">
                    <div className="text">
                        <p>The International Joint Laboratory (or Laboratoire Mixte International) <b>PRESTO</b> for <b>PR</b>otect-d<b>E</b>tect-<b>STO</b>p  aims to create a sustainable platform for research, diagnosis and training on emerging diseases at the human-animal-environment interface. IJL PRESTO includes researchers from various background and expertise covering Virology, bacteriology, infectious diseases, veterinary medicine, public health, ecology, social science, environmental science.
                            <br />This multidisciplinary team aims to:
                        </p>
                        <ul>
                            <li>Rapid identification of emerging zoonoses using epidemiological, behavioral and molecular studies in the environment, animals and humans</li>
                            <li>Development, validation and evaluation of new tools for prevention, diagnosis and surveillance</li>
                            <li>Filling knowledge gaps by acting as a hub for South East Asian researchers and students</li>
                        </ul>
                    </div>
                    <div className="img">
                        <img src={logo} alt="logo" />
                    </div>
                </div>
            </div>
            <hr />

{/* AIMS */}
        <div className="aims">
            <div className="container">
                {aims.map((aim) => (
                    <div className="items" style={{position:'relative'}}>
                        <div className='bgimg' style={{ 
                                backgroundImage: `url(${aim.bgimg})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                height: "100%", 
                                width: "100%",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                opacity: 0.3,
                                zIndex: -1,

                            }}>
                        </div>
                        <div className="img">
                            <img src={aim.imgSrc} alt="img" />
                        </div>
                        <div className="text">
                            <div className="head">
                                <b><u>{aim.head}</u></b>
                            </div>
                            <div className="details">
                                <p>{aim.details}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        <hr />

{/* coordinators */}
<h2>Coordinators</h2>
        <div className="team">
            <div className="containers th">
                <h3>Thailand</h3>
                <div className="items">
                    {coordinators
                    .filter(coordinators => coordinators.national === "TH")
                    .map((coordinator) => (
                        <div key={coordinator.id} className="leader-profile" data-key={coordinator.ini} onClick={handlePopup}>
                            <div className="profile-img">
                                <div className="img">
                                    <img src={coordinator.imgSrc ? coordinator.imgSrc : blank} alt="profile" />
                                </div>
                                <div className="text">
                                    <p>{coordinator.name}</p>
                                    {/* <a href={coordinator.orcidlink} target='_blank' rel='noreferrer'>{coordinator.orcid}</a>
                                    <a href={`mailto:${coordinator.email}`}>{coordinator.email}</a> */}
                                </div>
                            </div>
                            {/* <div className="cv">
                                <div className={`cv-cover-${coordinator.ini}`}>
                                    <div className="text-bg"></div>
                                    <div className="cv-text">
                                        <p>{Parse(coordinator.cv)}</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ))}
                </div>
            </div>

            <div className="containers laos">
                <h3>Laos</h3>
                <div className="items">
                    {coordinators
                    .filter(coordinators => coordinators.national === "LA")
                    .map((coordinator) => (
                        <div key={coordinator.id} className="leader-profile" data-key={coordinator.ini} onClick={handlePopup}>
                            <div className="profile-img">
                                <div className="img">
                                    <img src={coordinator.imgSrc ? coordinator.imgSrc : blank} alt="profile" />
                                </div>
                                <div className="text">
                                    <p>{coordinator.name}</p>
                                    {/* <a href={coordinator.orcidlink} target='_blank' rel='noreferrer'>{coordinator.orcid}</a>
                                    <a href={`mailto:${coordinator.email}`}>{coordinator.email}</a> */}
                                </div>
                            </div>
                            {/* <div className="cv">
                                <div className={`cv-cover-${coordinator.ini}`}>
                                    <div className="text-bg"></div>
                                    <div className="cv-text">
                                        <p>{Parse(coordinator.cv)}</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ))}
                </div>
            </div>

            <div className="containers fr">
                <h3>France</h3>
                <div className="items">
                    {coordinators
                    .filter(coordinators => coordinators.national === "FR")
                    .map((coordinator) => (
                        <div key={coordinator.id} className="leader-profile" data-key={coordinator.ini} onClick={handlePopup}>
                            <div className="profile-img">
                                <div className="img">
                                    <img src={coordinator.imgSrc ? coordinator.imgSrc : blank} alt="profile" />
                                </div>
                                <div className="text">
                                    <p>{coordinator.name}</p>
                                    {/* <a href={coordinator.orcidlink} target='_blank' rel='noreferrer'>{coordinator.orcid}</a>
                                    <a href={`mailto:${coordinator.email}`}>{coordinator.email}</a> */}
                                </div>
                            </div>
                            {/* <div className="cv">
                                <div className={`cv-cover-${coordinator.ini}`}>
                                    <div className="text-bg"></div>
                                    <div className="cv-text">
                                        <p>{Parse(coordinator.cv)}</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
<hr />

<h2>Members</h2>
    <div className="member team">    
        <div className="containers th">
            <div className="items">
                {members
                .map((member) => (
                    <div key={member.id} className="leader-profile" data-key={member.ini} onClick={handlePopup}>
                        <div className="profile-img">
                            <div className="img">
                                <img src={member.imgSrc ? member.imgSrc : blank} alt="profile" />
                            </div>
                            <div className="text">
                                <p>{member.name}</p>
                                {/* <a href={member.orcidlink} target='_blank' rel='noreferrer'>{member.orcid}</a>
                                <a href={`mailto:${member.email}`}>{member.email}</a> */}
                            </div>
                        </div>
                        {/* <div className="cv">
                            <div className={`cv-cover-${coordinator.ini}`}>
                                <div className="text-bg"></div>
                                <div className="cv-text">
                                    <p>{Parse(coordinator.cv)}</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                ))}
            </div>
        </div>
    </div>
<hr />


{/* POPUP */}
{/* Coordinators */}
            <div className="items-popup popup">
                {coordinators.map((coordinator) =>(
                    <div key={coordinator.id} className={`containers ${coordinator.ini} ${active === coordinator.ini ? 'active' : ''}`} >
                        <div className="cross" onClick={handlePopup}>
                            <i className="pi pi-times"></i>
                        </div>
                        <div className="items-img">
                            <img src={coordinator.imgSrc ? coordinator.imgSrc : blank} alt="profile" />
                            <div className="head">
                                <h2>{coordinator.name}</h2>
                                <div className="orcid">
                                    <a href={coordinator.orcidlink} target='_blank' rel='noreferrer'>{coordinator.orcid}</a>
                                </div>
                                <div className="email">
                                    <a href={`mailto:${coordinator.email}`}>{coordinator.email}</a>
                                </div>
                            </div>
                        </div>
                        
                        <div className="text">
                            <div className="cv"><p>{Parse(coordinator.cv)}</p></div>
                        </div>
                    </div>
                ))}
            </div>
{/* Members */}
            <div className="items-popup popup">
                {members.map((member) =>(
                    <div key={member.id} className={`containers ${member.ini} ${active === member.ini ? 'active' : ''}`} >
                        <div className="cross" onClick={handlePopup}>
                            <i className="pi pi-times"></i>
                        </div>
                        <div className="items-img">
                            <img src={member.imgSrc ? member.imgSrc : blank} alt="profile" />
                            <div className="head">
                                <h2>{member.name}</h2>
                                <div className="orcid">
                                    <a href={member.orcidlink} target='_blank' rel='noreferrer'>{member.orcid}</a>
                                </div>
                                <div className="email">
                                    <a href={`mailto:${member.email}`}>{member.email}</a>
                                </div>
                            </div>
                        </div>
                        
                        <div className="text">
                            <div className="cv"><p>{Parse(member.cv)}</p></div>
                        </div>
                    </div>
                ))}
            </div>
            {/* <div className="students-popup popup">
                {students.map((student) =>(
                    <div key={student.id} className={`containers ${student.ini} ${active === student.ini ? 'active' : ''}`} >
                        <div className="cross" onClick={handlePopup}>
                            <i className="pi pi-times"></i>
                        </div>
                        <div className="students-img">
                            <img src={student.imgSrc} alt="profile" />
                        </div>
                        <div className="text">
                            <div className="head">
                                <h2>{student.name}</h2>
                                <h3>{student.position}</h3>
                            </div>
                            <div className="email"><a href={`mailto:${student.email}`}>{student.email}</a></div>
                            <div className="cv">{student.cv}</div>
                        </div>
                    </div>
                ))}
            </div> */}
        </div>
    )
}

export default Aboutus